export enum CornerstoneTool {
  Zoom = 'Zoom',
  Wwwc = 'Wwwc',
  Pan = 'Pan',
  EraseCircleBrush = 'EraseCircleBrush',
  EraseSquareBrush = 'EraseSquareBrush',
  CircleBrush = 'CircleBrush',
  SquareBrush = 'SquareBrush',
  CustomPolylineFreehand = 'CustomPolylineFreehand',
  ShowDiff = 'ShowDiff',
  Rotate = 'Rotate',
  Restore = 'Restore',
  ResetDiff = 'ResetDiff',
  EmptyTool = 'EmptyTool',
}
